import { useEffect as useEffect } from 'react';
import {
  invoke3e9ytlmskvi4s as invoke,
  invoke2ywiw9ln9yogo as invoke_0,
} from './raw/EffectHook.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function useEffect_0(dependencies, effect) {
  invoke(useEffect, effect, dependencies);
}
function useEffectOnce(effect) {
  var tmp = useEffect;
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  invoke(tmp, effect, tmp$ret$0);
}
function useEffect_1(effect) {
  invoke_0(useEffect, effect);
}
//region block: exports
export {
  useEffectOnce as useEffectOncetplizg4bhfpf,
  useEffect_0 as useEffect1jlgi6hiv8qwn,
  useEffect_1 as useEffect1da557qj63kxq,
};
//endregion

//# sourceMappingURL=useEffect.mjs.map
